module.exports = __webpack_public_path__ + "media/images/lb/868-5af9270f04dc823378cab6a4c944d152.svg";